function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "99d4e2f409"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 60.5625 37.5 L 314 37.5 L 314 337 L 60.5625 337 Z M 60.5625 37.5 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#99d4e2f409)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 310.183594 95.085938 C 307.863281 92.453125 304.605469 90.933594 301.175781 90.84375 C 274.570312 90.144531 240.90625 61.699219 218.648438 50.535156 C 204.898438 43.660156 195.824219 39.128906 189.007812 37.933594 C 188.300781 37.839844 187.617188 37.773438 186.921875 37.773438 C 186.226562 37.773438 185.539062 37.839844 184.832031 37.945312 C 178.015625 39.140625 168.941406 43.671875 155.203125 50.546875 C 132.945312 61.699219 99.28125 90.144531 72.675781 90.84375 C 69.246094 90.933594 65.976562 92.464844 63.65625 95.085938 C 61.316406 97.703125 60.109375 101.195312 60.285156 104.753906 C 66 220.945312 107.675781 292.851562 180.800781 334.644531 C 182.699219 335.722656 184.808594 336.277344 186.910156 336.277344 C 189.007812 336.277344 191.117188 335.722656 193.03125 334.644531 C 266.15625 292.851562 307.816406 220.945312 313.542969 104.753906 C 313.730469 101.195312 312.523438 97.703125 310.183594 95.085938 Z M 252.035156 140.78125 L 190.328125 231.839844 C 188.113281 235.109375 184.636719 237.277344 181.195312 237.277344 C 177.738281 237.277344 173.902344 235.386719 171.480469 232.964844 L 127.984375 189.460938 C 125.027344 186.492188 125.027344 181.679688 127.984375 178.722656 L 138.730469 167.957031 C 141.699219 165.011719 146.519531 165.011719 149.464844 167.957031 L 177.75 196.242188 L 226.890625 123.707031 C 229.234375 120.253906 233.972656 119.359375 237.441406 121.703125 L 250.019531 130.234375 C 253.472656 132.585938 254.375 137.316406 252.035156 140.78125 Z M 252.035156 140.78125 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
function SvgGarantizadoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarantizadoIcon);
export default __webpack_public_path__ + "static/media/garantizado-icon.2888753f0dfbb2fd409a2544af2ec1cf.svg";
export { ForwardRef as ReactComponent };